import {
  TruckerProfileState,
  Reducer,
  ReducerActions,
  TruckerProfileStateAction,
  truckerProfileActions,
} from '@/context/types';

const makeTruckerProfileStateInitialState = (): TruckerProfileState => ({
  data: {},
  isAllDone: false,
  isLoading: false,
  isLoaded: false,
  triedSearch: false,
  isAutoLoaded: false,
  isAutoLoading: false,
  isAllAutoLoaded: false,
  isCpfAutoLoaded: false,
  isCellPhoneAutoLoaded: false,
});

const reducerActions: ReducerActions<TruckerProfileState, TruckerProfileStateAction> = (state, payload) => ({
  trucker_profile_load_start: () => ({ ...state, isLoaded: false, isLoading: true }),
  trucker_profile_load_end: () => ({ ...state, isLoading: false }),
  trucker_profile_auto_load_start: () => ({ ...state, isAutoLoading: true }),
  trucker_profile_all_auto_loaded: () => ({ ...state, isAllAutoLoaded: payload }),
  trucker_profile_set_all_done: () => ({ ...state, isAllDone: payload }),
  trucker_profile_auto_load_end: () => ({
    ...state,
    isAutoLoading: false,
    isAutoLoaded: payload,
    isAllAutoLoaded: payload === false ? false : state.isAllAutoLoaded,
    isCellPhoneAutoLoaded: payload && !!state.data.cellPhone,
    isCpfAutoLoaded: payload && !!state.data.cpf,
  }),
  trucker_profile_try_search: () => ({ ...state, triedSearch: true }),
  trucker_profile_clean_data: () => ({
    ...state,
    data: {
      truckerIsActive: payload.truckerIsActive,
      isSelfValid: payload.isSelfValid,
      isRegistered: payload.isRegistered,
      isDriverPhone: payload.isDriverPhone,
    },
  }),
  trucker_profile_update_data: () => ({
    ...state,
    isLoaded: true,
    isLoading: false,
    triedSearch: false,
    data: { ...payload },
  }),
});

export const TruckerProfileReducer: Reducer<TruckerProfileState, TruckerProfileStateAction> = (
  state,
  { action, payload },
) => (truckerProfileActions.includes(action) ? reducerActions(state, payload)[action]() : { ...state });

TruckerProfileReducer.key = 'truckerProfile';
TruckerProfileReducer.initialState = makeTruckerProfileStateInitialState();
